import PropTypes from 'prop-types';

// material-ui
import { Box } from '@mui/material';

// project import
import MainCard from '../../../component/cards/MainCard';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

function AuthCardWrapper({ children, ...other }) {
    return (
        <MainCard
            sx={{
                border: '1px solid',
                borderColor: 'primary.main',
                maxWidth: { xs: 450, lg: 525 },
                margin: { xs: 2.5, md: 3 },
                '& > *': {
                    flexGrow: 1,
                    flexBasis: '50%'
                }
            }}
            content={false}
            {...other}
        >
            <Box sx={{ p: { xs: 2, sm: 3, xl: 5 } }}>{children}</Box>
        </MainCard>
    );
}

AuthCardWrapper.propTypes = {
    children: PropTypes.node
};

export default AuthCardWrapper;
